import { useState } from 'react';

import { useBridgeEvents } from '@realTimeDataAccess';
import { GensetChanged, GensetInfo } from '@scaleaq/sitecontrol-lib';

const genSetChangedEventName = new GensetChanged().className;

export const useGetGenerators = () => {
  const [generators, setGenerators] = useState<Record<number, GensetInfo>>();

  const callBack = (_: string, __: string, data: GensetChanged | undefined) => {
    if (data) {
      const { deviceInfo, deviceInfo: { index } = {} } = data;
      if (deviceInfo && index) {
        setGenerators(prev => ({ ...prev, [index]: deviceInfo }));
      }
    }
  };
  const { isLoading, isError } = useBridgeEvents([genSetChangedEventName], callBack);
  return { generators, isLoading, isError };
};
